var map = {
	"./2021/images/apidays-2021-banner.jpg": "4e32",
	"./2021/images/apidays-2021-snapshot-1.jpg": "9196",
	"./2021/images/apidays-2021-snapshot-2.jpg": "c4e7",
	"./2021/images/apidays-2021-snapshot-3.jpg": "e0fd",
	"./2021/images/apidays-2021-snapshot-4.jpg": "9395",
	"./2021/images/apidays-2021-snapshot-5.jpg": "9fba",
	"./2021/images/apidays-2021-snapshot-6.jpg": "84fb",
	"./2021/images/apidays-live-hongkong-2021-agenda-825.png": "5b2d",
	"./2021/images/apidays-live-hongkong-2021-agenda-826.png": "9290",
	"./2021/images/apidays-live-hongkong-2021-participants.png": "3e92",
	"./2021/images/apidays-live-hongkong-2021-video-cover.jpg": "a35f",
	"./2021/images/hongkong.jpg": "2aa0",
	"./2021/speakers/ajay-pro.jpg": "f0d5",
	"./2021/speakers/alanc-pro.jpg": "800c",
	"./2021/speakers/alang-pro.jpg": "b310",
	"./2021/speakers/andrew-pro.jpg": "16bc",
	"./2021/speakers/archana-pro.jpg": "ecf7",
	"./2021/speakers/asanka-pro.jpg": "3333",
	"./2021/speakers/carl-pro.jpg": "7dfc",
	"./2021/speakers/claire-pro.jpg": "15c2",
	"./2021/speakers/clive-pro.jpg": "c665",
	"./2021/speakers/damir-pro.jpg": "636c",
	"./2021/speakers/david-pro.jpg": "bcb9",
	"./2021/speakers/default-speaker.jpg": "68b5",
	"./2021/speakers/derek-pro.jpg": "4558",
	"./2021/speakers/div-pro.jpg": "041d",
	"./2021/speakers/eason-pro.jpg": "63b0",
	"./2021/speakers/emmelyn-pro.jpg": "1593",
	"./2021/speakers/gan-pro.jpg": "1354",
	"./2021/speakers/geoffrey-pro.jpg": "ade4",
	"./2021/speakers/greg-pro.jpg": "1d8f",
	"./2021/speakers/hieu-pro.jpg": "2140",
	"./2021/speakers/howard-pro.jpg": "018f",
	"./2021/speakers/hugo-pro.jpg": "220e",
	"./2021/speakers/isaac-pro.jpg": "3616",
	"./2021/speakers/jason-pro.jpg": "1454",
	"./2021/speakers/jeffrey-pro.jpg": "e80e",
	"./2021/speakers/jenks-pro.jpg": "b545",
	"./2021/speakers/jeremy-pro.jpg": "bd34",
	"./2021/speakers/jesus-pro.jpg": "7410",
	"./2021/speakers/jimmy-pro.jpg": "8fd2",
	"./2021/speakers/john-pro.jpg": "172c",
	"./2021/speakers/jonathan-pro.jpg": "253f",
	"./2021/speakers/kim-pro.jpg": "4b7c",
	"./2021/speakers/laurent-pro.jpg": "2f7f",
	"./2021/speakers/marco-pro.jpg": "33d9",
	"./2021/speakers/marjukka-pro.jpg": "627d",
	"./2021/speakers/mathieu-pro.jpg": "0720",
	"./2021/speakers/matthias-pro.jpg": "5274",
	"./2021/speakers/maxime-pro.jpg": "290c",
	"./2021/speakers/maximeb-pro.jpg": "ff2b",
	"./2021/speakers/maximet-pro.jpg": "35b6",
	"./2021/speakers/mehdi-pro.jpg": "c2ab",
	"./2021/speakers/morris-pro.jpg": "b7c8",
	"./2021/speakers/naveen-pro.jpg": "41fe",
	"./2021/speakers/nicky-pro.jpg": "67c6",
	"./2021/speakers/nitin-pro.jpg": "7b52",
	"./2021/speakers/patrick-pro.jpg": "9ee6",
	"./2021/speakers/phil-pro.jpg": "bc63",
	"./2021/speakers/pricilla-pro.jpg": "7d65",
	"./2021/speakers/rana-pro.jpg": "3c41",
	"./2021/speakers/richard-pro.jpg": "5a4b",
	"./2021/speakers/rob-pro.jpg": "5b14",
	"./2021/speakers/rosemary-pro.jpg": "7d28",
	"./2021/speakers/shahnawaz-pro.jpg": "fdfe",
	"./2021/speakers/shiroshica-pro.jpg": "3c1c",
	"./2021/speakers/siddhant-pro.jpg": "0e54",
	"./2021/speakers/simen-pro.jpg": "8654",
	"./2021/speakers/simon-pro.jpg": "df80",
	"./2021/speakers/simonw-pro.jpg": "c0b0",
	"./2021/speakers/snehal-pro.jpg": "2505",
	"./2021/speakers/stuart-pro.jpg": "25e6",
	"./2021/speakers/tharika-pro.jpg": "5863",
	"./2021/speakers/toa-pro.jpg": "c9583",
	"./2021/speakers/trevor-pro.jpg": "969b7",
	"./2021/speakers/uli-pro.jpg": "33e5",
	"./2021/sponsors/amadeus.png": "e23f",
	"./2021/sponsors/confluent.png": "37bd",
	"./2021/sponsors/hkcs.png": "110d",
	"./2021/sponsors/hkstpsaa.png": "454e",
	"./2021/sponsors/ibm.png": "0215",
	"./2021/sponsors/mulesoft.png": "d993",
	"./2021/sponsors/new-relic.png": "d5c5",
	"./2021/sponsors/softwareag.png": "d4b6b",
	"./2022/images/apidays-2022-snapshot-1.jpg": "a03c",
	"./2022/images/apidays-2022-snapshot-2.jpg": "53d4",
	"./2022/images/apidays-2022-snapshot-charm-1.jpg": "013c",
	"./2022/images/apidays-2022-snapshot-gary-1.jpg": "ace2",
	"./2022/images/apidays-2022-snapshot-richard-1.jpg": "6f89",
	"./2022/images/apidays-2022-snapshot-trevor-1.jpg": "d21d",
	"./2022/images/apidays-hongkong-2022-agenda-0824.png": "72f9",
	"./2022/images/apidays-hongkong-2022-agenda-0825.png": "0259",
	"./2022/images/apidays-hongkong-2022-logo.png": "e9b8",
	"./2022/images/apidays-hongkong-2022-participants.jpg": "66f1",
	"./2022/images/apidays-hongkong-2022-video-cover.jpg": "8921",
	"./2022/speakers/alvin-pro.jpg": "2230",
	"./2022/speakers/bob-pro.jpg": "10dc",
	"./2022/speakers/brad-pro.jpg": "cb1f",
	"./2022/speakers/christine-pro.jpg": "6941",
	"./2022/speakers/clive-pro.jpg": "8193",
	"./2022/speakers/dale-pro.jpg": "e9b7",
	"./2022/speakers/default-speaker.jpg": "b082",
	"./2022/speakers/derric-pro.jpg": "39c1",
	"./2022/speakers/developersteve-pro.jpg": "67a7",
	"./2022/speakers/eason-pro.jpg": "5a54",
	"./2022/speakers/enrique-pro.jpg": "521d",
	"./2022/speakers/frederic-pro.jpg": "cfae",
	"./2022/speakers/gary-pro.jpg": "83c8",
	"./2022/speakers/garyl-pro.jpg": "3789",
	"./2022/speakers/giovanni-pro.jpg": "be94",
	"./2022/speakers/giri-pro.jpg": "9aac",
	"./2022/speakers/issac-pro.jpg": "089c",
	"./2022/speakers/jeffrey-pro.jpg": "a613",
	"./2022/speakers/jeremy-pro.jpg": "d8b4",
	"./2022/speakers/jimmy-pro.jpg": "cf39",
	"./2022/speakers/joey-pro.jpg": "6eb8",
	"./2022/speakers/jonathan-pro.jpg": "835d",
	"./2022/speakers/kenneth-pro.jpg": "4091",
	"./2022/speakers/martin-pro.jpg": "8b6f",
	"./2022/speakers/mary-pro.jpg": "4475",
	"./2022/speakers/matt-pro.jpg": "0661",
	"./2022/speakers/mehdi-pro.jpg": "53b9",
	"./2022/speakers/michael-pro.jpg": "ac05",
	"./2022/speakers/motti-pro.jpg": "5bc3",
	"./2022/speakers/nelson-pro.jpg": "1539",
	"./2022/speakers/nicolas-pro.jpg": "1b7f",
	"./2022/speakers/patrick-pro.jpg": "4c8e",
	"./2022/speakers/paul-pro.jpg": "1f07",
	"./2022/speakers/ray-pro.jpg": "3805",
	"./2022/speakers/richard-pro.jpg": "23ae",
	"./2022/speakers/rob-pro.jpg": "1031",
	"./2022/speakers/sanvy-pro.jpg": "a5d8",
	"./2022/speakers/simon-pro.jpg": "4efd",
	"./2022/speakers/sonal-pro.jpg": "9027",
	"./2022/speakers/steve-pro.jpg": "f58e",
	"./2022/speakers/steven-pro.jpg": "d8e0",
	"./2022/speakers/sunny-pro.jpg": "d388",
	"./2022/speakers/toa-pro.jpg": "1fd1",
	"./2022/speakers/trevor-pro.jpg": "bff7",
	"./2022/speakers/uli-pro.jpg": "7a68",
	"./2022/speakers/wilson-pro.jpg": "de66",
	"./2022/speakers/zhiyuan-pro.jpg": "9b31",
	"./2022/sponsors/aws.png": "ffc1",
	"./2022/sponsors/confluent.png": "5dc0",
	"./2022/sponsors/hkcs.png": "af3d",
	"./2022/sponsors/hkstpsaa.png": "f58ea",
	"./2022/sponsors/new-relic.png": "e2fc",
	"./2022/sponsors/openapihub.png": "ca48",
	"./images/apidays-2020-facts.png": "2f9b",
	"./images/apidays-HongKong-logowall.png": "dce6",
	"./images/apidays-banner-light.jpg": "c68a",
	"./images/apidays-banner.jpg": "9848",
	"./images/apidays-live-hongkong-2020agenda.png": "c9a2",
	"./images/apidays-onsite-1.jpg": "2102",
	"./images/apidays-onsite-2.jpg": "e25e",
	"./images/apidays-onsite-3.jpg": "c3f6",
	"./images/apidays-ppt-1.png": "72c2",
	"./images/apidays-ppt-2.png": "8c73",
	"./images/apidays-ppt-3.png": "9c49",
	"./images/apidays-ppt-4.png": "2969",
	"./images/apidays-ppt-5.png": "3c06",
	"./images/apidays.jpg": "c47d",
	"./organisers/apidays-2022.png": "f318",
	"./organisers/apidays-live-hk-color.png": "8fac",
	"./organisers/apidays.png": "b8da",
	"./organisers/benovelty.png": "f858",
	"./organisers/hkstp.png": "dae5",
	"./speakers/alan-pro.jpg": "7cec",
	"./speakers/alan-smc.jpg": "30a6",
	"./speakers/alex-pro.jpg": "2f835",
	"./speakers/alex-smc.jpg": "c5af",
	"./speakers/anna-pro.jpg": "6723",
	"./speakers/anna-smc.jpg": "3077",
	"./speakers/asanka-pro.jpg": "b954",
	"./speakers/asanka-smc.jpg": "49b6",
	"./speakers/atsushi-pro.jpg": "6d75",
	"./speakers/atsushi-smc.jpg": "aa4a",
	"./speakers/barry-pro.jpg": "7e45",
	"./speakers/barry-smc.jpg": "f8f0",
	"./speakers/ben-pro.jpg": "38d5",
	"./speakers/ben-smc.jpg": "df7d",
	"./speakers/daniele-pro.jpg": "119e",
	"./speakers/daniele-smc.jpg": "cbc1",
	"./speakers/david-pro.jpg": "b63e",
	"./speakers/david-smc.jpg": "2277",
	"./speakers/developersteve-pro.jpg": "bc27",
	"./speakers/developersteve-smc.jpg": "f888",
	"./speakers/donnie-pro.jpg": "7933",
	"./speakers/donnie-smc.jpg": "419c",
	"./speakers/forest-pro.jpg": "6366",
	"./speakers/forest-smc.jpg": "5707",
	"./speakers/fran-pro.jpg": "5569",
	"./speakers/fran-smc.jpg": "24c2",
	"./speakers/garry-pro.jpg": "aa2f",
	"./speakers/garry-smc.jpg": "8b24",
	"./speakers/greg-pro.jpg": "3539",
	"./speakers/greg-smc.jpg": "0bb9",
	"./speakers/hieu-pro.jpg": "8065",
	"./speakers/hieu-smc.jpg": "fd99",
	"./speakers/hugo-pro.jpg": "a2ee",
	"./speakers/hugo-smc.jpg": "6259",
	"./speakers/ilona-pro.jpg": "fded",
	"./speakers/ilona-smc.jpg": "1074",
	"./speakers/img12.jpg": "6681",
	"./speakers/jed-pro.jpg": "b05a",
	"./speakers/jed-smc.jpg": "123e",
	"./speakers/jenks-pro.jpg": "85c4",
	"./speakers/jenks-smc.jpg": "6e42",
	"./speakers/johan-pro.jpg": "c593",
	"./speakers/johan-smc.jpg": "5341",
	"./speakers/john-pro.jpg": "0717",
	"./speakers/john-smc.jpg": "3686",
	"./speakers/julian-pro.jpg": "bba8",
	"./speakers/julian-smc.jpg": "e8ab",
	"./speakers/maciej-pro.jpg": "0241",
	"./speakers/maciej-smc.jpg": "b475",
	"./speakers/marco-pro.jpg": "0481",
	"./speakers/marco-smc.jpg": "f30d",
	"./speakers/michelle-pro.jpg": "7711",
	"./speakers/michelle-smc.jpg": "ea4c",
	"./speakers/nicky-pro.jpg": "c015",
	"./speakers/nicky-smc.jpg": "f282",
	"./speakers/patrick-pro.jpg": "cd34",
	"./speakers/patrick-smc.jpg": "8724",
	"./speakers/paul-pro.jpg": "042f",
	"./speakers/paul-smc.jpg": "3ab5",
	"./speakers/phil-pro.jpg": "72ca",
	"./speakers/phil-smc.jpg": "904d",
	"./speakers/rajesh-pro.jpg": "7f7c",
	"./speakers/rajesh-smc.jpg": "3509",
	"./speakers/richard-pro.jpg": "11e7",
	"./speakers/richard-smc.jpg": "e6cd",
	"./speakers/rob-pro.jpg": "5eae",
	"./speakers/rob-smc.jpg": "bd67",
	"./speakers/samuel-pro.jpg": "4d53",
	"./speakers/samuel-smc.jpg": "1d1c",
	"./speakers/shahnawaz-pro.jpg": "ddce",
	"./speakers/shahnawaz-smc.jpg": "59b2",
	"./speakers/simon-pro.jpg": "cf61",
	"./speakers/simon-smc.jpg": "0b4b",
	"./speakers/stanley-pro.jpg": "7f2c",
	"./speakers/stanley-smc.jpg": "e79d",
	"./speakers/zeev-pro.jpg": "1730",
	"./speakers/zeev-smc.jpg": "89f6",
	"./sponsors/alibaba-cloud.png": "5a57",
	"./sponsors/apisfirst.png": "8820",
	"./sponsors/auth0.png": "519e",
	"./sponsors/daops.png": "817c",
	"./sponsors/forgerock.png": "dfbd",
	"./sponsors/ibm.png": "d82fc",
	"./sponsors/nginx.png": "bbd4",
	"./sponsors/wia.png": "a9a2",
	"./sponsors/wso2.png": "4b20"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79e3";